import { useEffect, useState } from 'react';
import { api } from '../api';

export default function Users() {
  const [users, setUsers] = useState<any[]>([]);
  const [depts, setDepts] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState<any>({
    username: '',
    password: '',
    name: '',
    department_id: '',
    role_ids: [],
  });

  const load = () => {
    setLoading(true);
    setError('');
    const done = () => setLoading(false);
    Promise.all([
      api('/users').then(setUsers).catch((e) => setError(e.message || '加载用户失败')),
      api('/departments').then(setDepts).catch(() => {}),
      api('/roles').then(setRoles).catch(() => {}),
    ])
      .then(done, done)
      .catch(done);
  };
  useEffect(load, []);

  const submit = async () => {
    if (!form.username || !form.password) return alert('用户名和密码必填');
    await api('/users', {
      method: 'POST',
      body: JSON.stringify({ ...form, department_id: form.department_id || null, role_ids: form.role_ids }),
    });
    setForm({ username: '', password: '', name: '', department_id: '', role_ids: [] });
    load();
  };

  const resetPwd = async (id: number) => {
    const p = prompt('输入新密码');
    if (!p) return;
    await api('/users/' + id + '/reset-password', {
      method: 'POST',
      body: JSON.stringify({ password: p }),
    });
    alert('已重置');
  };

  const del = async (id: number) => {
    if (!confirm('确认删除该用户？')) return;
    await api('/users/' + id, { method: 'DELETE' });
    load();
  };

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold">用户管理</h2>
      {loading && <div className="text-sm text-slate-400">加载中…</div>}
      {error && (
        <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2 flex items-center justify-between">
          <span>{error}</span>
          <button onClick={load} className="ml-3 text-xs px-2 py-1 bg-red-600 text-white rounded hover:bg-red-700">重试</button>
        </div>
      )}
      <div className="bg-white rounded-xl shadow p-4 grid grid-cols-5 gap-2 items-end">
        <input
          className="border rounded px-2 py-1"
          placeholder="用户名"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
        />
        <input
          className="border rounded px-2 py-1"
          placeholder="初始密码"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
        <input
          className="border rounded px-2 py-1"
          placeholder="姓名"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <select
          className="border rounded px-2 py-1"
          value={form.department_id}
          onChange={(e) => setForm({ ...form, department_id: e.target.value })}
        >
          <option value="">选择部门</option>
          {depts.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        <button onClick={submit} className="bg-brand-600 text-white rounded px-3 py-1 hover:bg-brand-700">
          新增用户
        </button>
        <div className="col-span-5 flex flex-wrap gap-3">
          {roles.map((r) => (
            <label key={r.id} className="text-sm flex items-center gap-1">
                <input
                  type="checkbox"
                  checked={form.role_ids.indexOf(r.id) !== -1}
                  onChange={(e) => {
                    const v = [...form.role_ids];
                    e.target.checked ? v.push(r.id) : v.splice(v.indexOf(r.id), 1);
                    setForm({ ...form, role_ids: v });
                  }}
                />
              {r.name}
            </label>
          ))}
        </div>
      </div>
      <table className="w-full bg-white rounded-xl shadow text-sm">
        <thead>
          <tr className="text-slate-500 text-left">
            <th className="p-3">用户名</th>
            <th>姓名</th>
            <th>部门</th>
            <th>角色</th>
            <th>状态</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} className="border-t">
              <td className="p-3">{u.username}</td>
              <td>{u.name}</td>
              <td>{depts.find((d) => d.id === u.department_id)?.name || '—'}</td>
              <td>{(u.roles || []).map((r: any) => r.name).join('、')}</td>
              <td>{u.status}</td>
              <td className="space-x-2">
                <button className="text-brand-600" onClick={() => resetPwd(u.id)}>
                  重置密码
                </button>
                <button className="text-red-500" onClick={() => del(u.id)}>
                  删除
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
